import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import HomePage from "./pages/HomePage";
import EvaluationPage from "./pages/EvaluationPage";
import CheckoutPage from "./pages/CheckoutPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/evaluation" element={<EvaluationPage />} />
          <Route path="/checkout/:evaluationId" element={<CheckoutPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
